<template>
  <div class="collection-item">
    <div class="collection-name">
      <span v-if="isSaving" class="saving-indicator" :data-testid="`collections-modal-loader-${collection.id}`"
        ><Icon name="general.spinner" size="base"
      /></span>
      <FormKit
        type="checkbox"
        v-model="isSelected"
        @change="$emit('toggle')"
        :label="collection.name"
        :data-testid="`collections-modal-list-checkbox-${collection.id}`"
      />
      <BaseBadge :data-testid="`collections-modal-list-badge-${collection.id}`">{{ collection.items.length }}</BaseBadge>
    </div>
    <div class="collection-author">
      by <span :title="collection.author">{{ collection.author }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CollectionItemInterface } from '@/store/useCollectionsStore';
import { BaseBadge, Icon } from '@/storybook';
import { ref, watch } from 'vue';

const props = defineProps<{
  selected: boolean;
  isSaving: boolean;
  collection: CollectionItemInterface;
}>();

const isSelected = ref(props.selected);
const $emit = defineEmits(['toggle']);

watch(
  () => props.selected,
  (newVal: boolean) => (isSelected.value = newVal)
);
</script>

<style scoped>
.collection-item {
  @apply flex justify-between items-center;
}
.collection-name {
  @apply relative max-w-[270px] flex gap-2 items-center;
}
:root .collection-name :deep(.formkit-wrapper) {
  @apply !mb-0;
}
:root .collection-name :deep(label > span:nth-child(2)) {
  @apply truncate max-w-[170px] md:max-w-full;
}
:root .collection-name :deep(.formkit-outer) {
  @apply shrink w-full;
}
.collection-author {
  @apply text-sm max-w-[120px] truncate;
}
.saving-indicator {
  @apply absolute z-50 -left-[4px] -top-px text-slate-400 dark:text-zinc-500 bg-white dark:bg-zinc-800;
}
</style>
